import React, { Component } from "react";
import "bootstrap/dist/js/bootstrap.bundle";
import { Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { withTranslation } from "react-i18next";

// Table data

class PaymentRTGS extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.products1 = [
      {
        id: "01",
        paymentMode: "Cash",
        paymentDate: "05/05/2022",
        paymentAmount: "₹ 1,25,325",
        remainingAmount: "₹ 25,325",
      },
      {
        id: "02",
        paymentMode: "Cheque",
        paymentDate: "05/05/2022",
        paymentAmount: "₹ 1,25,325",
        remainingAmount: "₹ 25,325",
      },
      {
        id: "03",
        paymentMode: "RTGS & UPI",
        paymentDate: "05/05/2022",
        paymentAmount: "₹ 1,25,325",
        remainingAmount: "₹ 25,325",
      },
      {
        id: "04",
        paymentMode: "Cheque",
        paymentDate: "05/05/2022",
        paymentAmount: "₹ 1,25,325",
        remainingAmount: "₹ 25,325",
      },
    ];
    this.products2 = [
      {
        id: "01",
        paymentDate: "05/05/2022",
        paymentTime: "₹ 1,25,325",
        remainderNotes: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
      },
      {
        id: "02",
        paymentDate: "05/05/2022",
        paymentTime: "₹ 1,25,325",
        remainderNotes: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
      },
      {
        id: "03",
        paymentDate: "05/05/2022",
        paymentTime: "₹ 1,25,325",
        remainderNotes: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
      },
      {
        id: "04",
        paymentDate: "05/05/2022",
        paymentTime: "₹ 1,25,325",
        remainderNotes: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
      },
    ];
  }

  render() {
    this.columns1 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
      },
      {
        dataField: "paymentMode",
        text: "PAYMENT MODE",
      },
      {
        dataField: "paymentDate",
        text: `${this.props.t("Payment Date")}`,
      },
      {
        dataField: "paymentAmount",
        text: `${this.props.t("Payment Amount")}`,
      },
      {
        dataField: "remainingAmount",
         text: `${this.props.t("Remaining Amount")}`,
      },
      {
        dataField: "viewDetail",
        text:`${this.props.t('View Details')}`,
        formatter: (cell, row) => (
          <button className="py-2 px-2 border-0 rounded ms-2">
            <img src="images/dashboard-images/view.svg" />
          </button>
        ),
      },
    ];
    this.columns2 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
      },
      {
        dataField: "paymentDate",
        text: `${this.props.t("Payment Date")}`,
      },
      {
        dataField: "paymentTime",
        text: "PAYMENT TIME",
      },
      {
        dataField: "remainderNotes",
        text: "Remainder notes",
      },
    ];

    document.title = "transaction-history";
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <h3 className="text-black fw-bold text-uppercase pb-4">
              {this.props.t("ADD PAYMENT")}
            </h3>
            <div className="row">
              <div className="col-xl-2">
                <div className="bg-white py-4 rounded shadow" onClick={() => this.props.history.push("/payment-cash")}>
                  <img
                    src="images/dashboard-images/cashpayment.svg"
                    alt="cashpayment"
                    className="mx-auto d-block"
                  />
                  <p className="text-center fs-4 pt-2 fw-bold">Cash</p>
                </div>
                <div className="bg-white mt-3 py-4 rounded shadow" onClick={() => this.props.history.push("/payment-cheque")}>
                  <img
                    src="images/dashboard-images/cheque.svg"
                    alt="cashpayment"
                    className="mx-auto d-block"
                  />
                  <p className="text-center fs-4 pt-2 fw-bold">Cheque</p>
                </div>
                <div className="bg-primary mt-3 py-4 rounded shadow">
                  <img
                    src="images/dashboard-images/googlepayhover.svg"
                    alt="cashpayment"
                    className="mx-auto d-block"
                  />
                  <p className="text-center text-white fs-4 pt-2">RTGS & UPI</p>
                </div>
              </div>
              <div className="col-xl-10">
                <div className="row text-center py-5">
                  <div className="col-xl-4">
                    <label htmlFor="invoiceAmount" className="fs-5 pe-3">
                      Total Invoice Amount
                    </label>
                    <input
                      type="text"
                      placeholder="₹ 1,25,325"
                      className="py-1 ps-1 border-gray-light rounded fs-5"
                    />
                  </div>
                  <div className="col-xl-4">
                    <label htmlFor="invoiceAmount" className="fs-5 pe-3">
                      Total Paid
                    </label>
                    <input
                      type="text"
                      placeholder="₹ 1,00,000"
                      className="py-1 ps-1 border-gray-light rounded fs-5"
                    />
                  </div>
                  <div className="col-xl-4">
                    <label htmlFor="invoiceAmount" className="fs-5 pe-3">
                      Total Pending
                    </label>
                    <input
                      type="text"
                      placeholder="₹ 25,325"
                      className="py-1 ps-1 border-gray-light rounded fs-5"
                    />
                  </div>
                </div>
                <div className="row ps-3">
                  <div className="bg-white py-5">
                    <h2 className="fw-bold text-black pb-3">Add Transfer Detail (RTGS & UPI Pay)</h2>
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <label htmlFor="selectBank" className="fs-4 fw-bold pe-5">
                        Select Bank
                        </label>
                      </div>
                      <div className="col-md-6">
                        <select 
                          className="form-control rounded fs-5">
                          
                          <option value="">Select Your Bank</option>
                          <option value="federal-bank">Federal Board</option>
                          <option value="federal-bank">Federal Board</option>
                          <option value="federal-bank">Federal Board</option>
                          </select>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <label htmlFor="payamount" className="fs-4 fw-bold pe-5">
                        Pay Amount
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          placeholder="₹ 1,00,000"
                          className="form-control rounded fs-5"
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <label htmlFor="date" className="fs-4 fw-bold pe-5">
                        Date
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="date"
                          className="form-control rounded fs-5"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mx-1 mt-3 py-4 bg-white shadow">
              <h3 className="text-black fw-bold py-2">{this.props.t("Remainder")}</h3>
              <div className="col-lg-4">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="invoiceAmount" className="fs-4 pe-5">
                      Date
                    </label>
                  </div>
                  <div className="col-md-9">
                    <input
                      type="date"
                      className="py-1 ps-2 form-control rounded fs-5"
                    />
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-md-3">
                    <label htmlFor="invoiceAmount" className="fs-4 pe-5">
                      Time
                    </label>
                  </div>
                  <div className="col-md-9">
                    <input
                      type="time"
                      placeholder="05:00 PM"
                      className="py-1 ps-2 form-control rounded fs-5"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="row">
                  <div className="col-md-3 text-lg-center text-start">
                    <label htmlFor="invoiceAmount" className="fs-4 pe-5">
                      Remainder Notes
                    </label>
                  </div>
                  <div className="col-md-9">
                    <textarea
                      type="date"
                      className="py-1 ps-2 form-control rounded fs-5"
                      rows="5"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 text-lg-end py-5 text-center no-print">
                <Button
                  color="primary"
                  className="fs-4 px-5 ms-2"
                  type="submit"
                >
                  Save
                </Button>
              </div>
            </div>
            <div className="row">
              <div className="bg-white py-5">
                <h3 className="text-black fw-bold">Past Payment Details</h3>

                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    responsive
                    bordered={false}
                    striped={false}
                    bootstrap4={true}
                    data={this.products1}
                    columns={this.columns1}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="bg-white py-5">
                <h3 className="text-black fw-bold">Remainder Summary</h3>

                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    responsive
                    bordered={false}
                    striped={false}
                    bootstrap4={true}
                    data={this.products2}
                    columns={this.columns2}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentRTGS);
